import React, { forwardRef } from 'react';
import Proptypes from 'prop-types';
import MaterialRadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '../FormControlLabel';
import { makeStyles } from '../../lib/styles';

const useStyles = makeStyles(theme => ({
  root: {
    '& > label > span.Mui-checked + span': {
      color: theme.palette.common.black,
    },
    '& > label': {
      color: theme.palette.grey[700],
    },
  },
}));

const RadioGroup = forwardRef(function RadioGroup(
  { className, defaultValue, value, onChange, children, ...restProps },
  ref
) {
  const classes = useStyles();

  return (
    <MaterialRadioGroup
      onChange={onChange}
      classes={classes}
      value={value}
      className={className}
      ref={ref}
      {...restProps}
    >
      {children}
    </MaterialRadioGroup>
  );
});

RadioGroup.propTypes = {
  className: Proptypes.string,
  defaultValue: Proptypes.string,
  onChange: Proptypes.func,
  value: Proptypes.string.isRequired,
  children: Proptypes.arrayOf(
    Proptypes.shape({
      type: Proptypes.oneOf([FormControlLabel]),
    })
  ).isRequired,
};

RadioGroup.defaultProps = {
  className: '',
  defaultValue: '',
  onChange: null,
};

RadioGroup.displayName = 'RadioGroup';

export default RadioGroup;
